
let BaseTest = require('@/mixins/Forms/2016/BaseTest')

module.exports = {

    mixins: [BaseTest],

    data(){
        return {
            testResult: 0
        }
    },

    methods: {

        resolveTest () {
            setInterval(() => {
                this.evaluateTest();
            }, 500)
        },

        evaluateTest () {
            for (var questionNumber = 1; questionNumber <= this.totalOfQuestions; questionNumber++) {
                if (! this.isSelected(questionNumber)) {
                    this.form.testResult = this.testResult =  0;
                    return;
                }
            }
            this.form.testResult = this.testResult =  1;
        },

        isSelected (questionNumber) {
            return $("input[name=att_question_" + questionNumber + "]:checked").val() == 1;
        }
    },
}
